import messageInformation from './messageInformation';

export default function messageErreur(i18n, message) {
  let toastMessage = i18n.t('validation.internalError');
  if (message) {
    toastMessage = message;
  }
  messageInformation(toastMessage, 'is-danger');
}
